import { createGyymApiClient, GyymClientOptions } from '@gyym/sdk'
import type { GetServerSidePropsContext } from 'next'

export interface ServerGyymClientOptions extends GyymClientOptions {
  ctx: GetServerSidePropsContext
  env?: string
  appName?: string
  appType?: string
}

const getSessionCookieKey = ({
  env = process.env.NEXT_PUBLIC_GYYM_ENV ?? 'local',
  appName = 'gyym',
  appType = 'user',
}: {
  env?: string
  appName?: string
  appType?: string
}) => `${env === 'prod' ? '' : `${env}_`}${appName}_${appType}_session`

export const createServerGyymApiClient = ({
  baseURL,
  headers,
  ctx,
  env,
  appName,
  appType,
}: ServerGyymClientOptions) => {
  const sessionKey = getSessionCookieKey({
    env: env ?? process.env.NEXT_PUBLIC_GYYM_ENV,
    appName: appName ?? 'gyym',
    appType: appType ?? 'user',
  })

  const sessionValue = ctx.req.cookies[sessionKey]

  const client = createGyymApiClient({
    baseURL: baseURL ?? process.env.NEXT_PUBLIC_API_HOST,
    headers: {
      ...headers,
      // Pass session cookie to the api client
      ['Cookie']: `${sessionKey}=${sessionValue};`,
    },
  })

  return client
}
